import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { ChartTooltip } from "@/components/ChartTooltip";
import { AXIS_TICK, CHART_MARGIN } from "@/components/chartChrome";
import { ChartEmptyState } from "@/components/states";
import { formatChartLabel, formatMonthDay } from "@/lib/format";

/**
 * Single-series daily area chart (ISO-date x-axis). Owns the axis/tooltip
 * date formatting and the empty state.
 */
export function TimeSeriesAreaChart({
  data,
  seriesName,
  height = 260,
}: {
  data: { day: string; value: number }[];
  seriesName: string;
  height?: number;
}) {
  if (data.length === 0) {
    return <ChartEmptyState />;
  }
  return (
    <ResponsiveContainer width="100%" height={height}>
      <AreaChart data={data} margin={CHART_MARGIN}>
        <CartesianGrid stroke="var(--viz-grid)" vertical={false} />
        <XAxis
          dataKey="day"
          tickFormatter={formatMonthDay}
          tick={AXIS_TICK}
          axisLine={{ stroke: "var(--viz-baseline)" }}
          tickLine={false}
          minTickGap={32}
        />
        <YAxis
          tickFormatter={(v: number) => formatChartLabel(v)}
          tick={AXIS_TICK}
          axisLine={false}
          tickLine={false}
          width={44}
        />
        <Tooltip
          content={<ChartTooltip labelFormatter={formatMonthDay} />}
          cursor={{ stroke: "var(--viz-baseline)", strokeWidth: 1 }}
        />
        <Area
          name={seriesName}
          dataKey="value"
          type="monotone"
          isAnimationActive={false}
          stroke="var(--viz-series-1)"
          strokeWidth={2}
          strokeLinecap="round"
          fill="var(--viz-series-1)"
          fillOpacity={0.1}
          dot={false}
          activeDot={{ r: 4, stroke: "var(--viz-surface)", strokeWidth: 2 }}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}
